import { render } from "./GuestCam.vue?vue&type=template&id=0d78e916&scoped=true"
import script from "./GuestCam.vue?vue&type=script&lang=js"
export * from "./GuestCam.vue?vue&type=script&lang=js"

import "./GuestCam.vue?vue&type=style&index=0&id=0d78e916&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0d78e916"

export default script